// Tutorial video topics shown on the Tutorial page and referenced by the
// Dashboard's "New here?" invite card. Videos aren't produced yet — every
// topic renders with the same "coming soon" placeholder used during
// onboarding until real videos are recorded and their URLs filled in below.
export const TUTORIAL_TOPICS = [
  {
    id: 'welcome',
    emoji: '👋',
    title: 'Welcome to Lineage Bible',
    description: "A quick hello, and what this app is really for.",
    videoUrl: null,
  },
  {
    id: 'record-first-verse',
    emoji: '🎙️',
    title: 'Recording Your First Verse',
    description: 'How the Record page works, one verse at a time.',
    videoUrl: null,
  },
  {
    id: 'chapter-plans',
    emoji: '📖',
    title: 'Choosing a Chapter Plan',
    description: 'A guided list of chapters to record, so you always know what to read next.',
    videoUrl: null,
  },
  {
    id: 'passage-plans',
    emoji: '✂️',
    title: 'Building Your Own Passage Plan',
    description: 'Pick your own favorite verses and record just those, in any order.',
    videoUrl: null,
  },
  {
    id: 'listening',
    emoji: '🎧',
    title: 'Listening as a Family',
    description: "Hear the Bible read in the voices of the people you love.",
    videoUrl: null,
  },
  {
    id: 'inviting-family',
    emoji: '💌',
    title: 'Inviting Your Family',
    description: 'Bring the rest of your family in, so everyone can record and listen together.',
    videoUrl: null,
  },
  {
    id: 'badges',
    emoji: '🏆',
    title: 'Badges & Streaks',
    description: 'Little rewards for showing up and reading, day after day.',
    videoUrl: null,
  },
  {
    id: 'study-notes',
    emoji: '📝',
    title: 'Study Notes',
    description: 'Jot down a thought on a verse and share it with your family.',
    videoUrl: null,
  },
  {
    id: 'recording-reminders',
    emoji: '⏰',
    title: 'Setting a Recording Reminder',
    description: 'Schedule a weekly nudge so you never lose the habit — pick your days and the time, and we\'ll remind you.',
    videoUrl: null,
  },
  {
    id: 'settings',
    emoji: '⚙️',
    title: 'Making It Yours',
    description: 'Text size, notifications, dark mode — set it up the way you like it.',
    videoUrl: null,
  },
  {
    id: 'help',
    emoji: '🤝',
    title: "Getting Help When You Need It",
    description: "Where to find answers, and how to reach a real person.",
    videoUrl: null,
  },
];
